export default __webpack_public_path__ + "static/media/categoryWhite.77854fe7.svg";